export default __webpack_public_path__ + "static/media/dadjokes.daa7a4c3.PNG";